import { connectFunctionsEmulator, getFunctions } from "firebase/functions"

import { app } from "./firebaseApp"

export const functions = getFunctions(app)

// Opt-in only — dev builds should hit real Cloud Functions unless a developer is
// deliberately running `firebase emulators:start` locally.
if (process.env.NODE_ENV === "development" && process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === "true") {
  connectFunctionsEmulator(functions, "localhost", 5001)
}
